<template>
  <BaseCheckbox
    v-model="formData.settings.sales.generateInvoiceAutomatically"
    :label="$t('admin.invoices.permissions.generate_invoice_automatically')"
    :description="$t('admin.invoices.permissions.generate_invoice_automatically_info')"
    v-test="'generateInvoiceAutomatically'"
  />
  <BaseInput
    v-if="formData.settings.sales.generateInvoiceAutomatically"
    type="number"
    v-model="formData.settings.sales.invoiceDueDateInDays"
    :label="$t('register.invoice.due_in')"
    :minValue="1"
    :maxValue="365"
    unitLabel="days"
    required
    v-test="'invoiceDueDateInDays'"
  />
</template>

<script
  lang="ts"
  setup
>
import { inject } from 'vue';
import type { InvoiceFormData } from './useInvoices';

const formData = inject<InvoiceFormData>('formData')!;
</script>
